import React, { useState } from "react";
import { useEffect } from "react";
import { Modal, Button, Form, Select } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { useParams } from 'react-router-dom';
import PostingScheduleField, { hasUsableEntry } from "./PostingScheduleField";
const { Option } = Select;
const tagRender = (props) => {
  const { label, value, closable, onClose } = props;
  return (
    <div key={value} className="multiselect-card-box edit-preferences-selected">
      <p>{label}</p>
      {closable && (
        <span
          className="remove-tag"               
          onClick={onClose}
          role="button"
          aria-label={`Remove ${label}`}
        >
          <CloseCircleFilled />
        </span>
      )}
    </div>
  );
};

const ClientPreferenceModal = ({ visible, onCancel,data,setRefresh }) => {
  const [form] = Form.useForm();
   const { id } = useParams();
   const { request } = useRequest();
  const handleFinish = (values) => {
    console.log("Form Values:", values);
     request({
      url: '/admin/access-module/client-prefernce'+`/${id}`,
      method: "POST",
      data:values,
      onSuccess: (data) => {
        if (data && data.data) {
          ShowToast(data.message,Severty.SUCCESS)
        } else {
          ShowToast(data.message,Severty.ERROR)
        }
      },
      onError: (error) => {
          ShowToast(error,Severty.ERROR)
      } 
    });
    setRefresh(Math.random());
    onCancel(); // Close modal
  };

  useEffect(() => {
  if (visible && data) {
    form.setFieldsValue({
      industry: data.industry || [],
      audience: data.audience || [],
      geography: data.geography || [],
      // Seed from the structured entries, not the derived `schedule` strings —
      // the backend regenerates those from whatever we send back.
      postingSchedule: data.postingSchedule || [],
    });
  }
}, [visible, data, form]);

  return (
   <Modal
  title="Edit Preferences Panel"
  className="table_modal"
  width={757}
  open={visible}
  onCancel={onCancel}
  footer={false}
>
  <Form form={form} layout="vertical" onFinish={handleFinish}>
    <Form.Item
      name="industry"
      label="Industry"
      rules={[{ required: true, message: "Please select at least one industry" }]}
    >
      <Select mode="tags" tagRender={tagRender} className="multi-select" placeholder="Select industry">
        <Select.Option value="Information Technology">Information Technology</Select.Option>
        <Select.Option value="Healthcare">Healthcare</Select.Option>
        <Select.Option value="Finance">Finance</Select.Option>
        <Select.Option value="Education">Education</Select.Option>
        <Select.Option value="Retail">Retail</Select.Option>
      </Select>
    </Form.Item>

    <Form.Item
      name="audience"
      label="Target Audience"
       rules={[{ required: true, message: "Please select at least one audience" }]}
    >
      <Select mode="tags" tagRender={tagRender} className="multi-select" placeholder="Select target audience">
        <Select.Option value="Students">Students</Select.Option>
        <Select.Option value="Entry-level professionals">Entry-level professionals</Select.Option>
        <Select.Option value="Mid-level IT professionals">Mid-level IT professionals</Select.Option>
        <Select.Option value="Startup founders">Startup founders</Select.Option>
        <Select.Option value="C-level executives">C-level executives</Select.Option>
      </Select>
    </Form.Item>

    <Form.Item
      name="geography"
      label="Geography"
      rules={[{ required: true, message: "Please select at least one geography" }]}
    >
      <Select mode="tags" tagRender={tagRender} className="multi-select" placeholder="Select geography">
        {[
          "North America (USA & Canada)",
          "Latin America (Brazil, Mexico, Argentina)",
          "Europe (Western)",
          "Europe (Eastern)",
          "United Kingdom & Ireland",
          "Scandinavia & Nordic Countries",
          "Middle East (UAE, Saudi Arabia)",
          "Africa (Sub-Saharan)",
          "North Africa",
          "South Asia (India, Pakistan, Bangladesh)",
          "East Asia (China, Japan, South Korea)",
          "Southeast Asia (Singapore, Malaysia, Indonesia)",
          "Central Asia",
          "Australia & New Zealand",
          "Global / Worldwide",
        ].map((g) => (
          <Select.Option key={g} value={g}>{g}</Select.Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item
      name="postingSchedule"
      label="Posting Schedule"
      rules={[
        {
          validator: (_, value) =>
            hasUsableEntry(value)
              ? Promise.resolve()
              : Promise.reject(new Error("Please add at least one posting schedule entry")),
        },
      ]}
    >
      <PostingScheduleField />
    </Form.Item>

  </Form>
  <div className="action-footer-buttons">
    <Button className="schedule-btn" onClick={onCancel}>Cancel</Button>
    <Button className="submitted-btn" onClick={() => form.submit()}>Save changes</Button>
  </div>
</Modal>
  );
};

export default ClientPreferenceModal;
